export const FileTrackerUserPermissions = {
  MayViewDashboard: 'FT-MVD',
  MayViewQuickView: 'FT-MVQV',
};

export const FileTrackerAdminPermissions = {
  ...FileTrackerUserPermissions,
  MayViewRecentFiles: 'FT-MVRF',
  MayViewStatsView: 'FT-MVSV',
  MayViewUploadTrend: 'FT-MVUT',
  MayViewUploadFile: 'FT-MVUF',
};

export const FileTrackerPermissions = {
  ...FileTrackerAdminPermissions,
};
